import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export async function joinWaitlist({ name, email }) {
  const { data } = await api.post('/waitlist', { name, email });
  return data;
}

export async function getWaitlistCount() {
  const { data } = await api.get('/waitlist/count');
  return data;
}
